<template lang="pug">
  .col-24.flexD.alignItemsCenter.flexDirectionColumn.justifyCenter.l-padding-bottom-4em.m-padding-top-4em
    q-parallax.m-hidden(:height="750" :speed="1" v-if="Common.IEVersion() == -1" style="height: 100vh; min-height: 60vw")
      template(v-slot:media)
        img(:src="img.bg" style="width:100%; object-fit: contain")
      .flexD.flexDirectionColumn.minWidth400.l-padding-top-8em.l-padding-bottom-8em.m-minWidthAuto.m-width-90-important(style="width: 40%")
        .col-24.flexD.justifyCenter.l-margin-bottom-2em
          .col-12.msFlexNegative
            img.col-24.block(:src="img.logo")
        .col-24
          .font-section.textAlignLeft(v-for="(item, index) in items" :key="index") {{ item.content }}
        .col-24.flexD.justifyCenter.l-margin-top-2em.l-margin-bottom-2em
          .col-4.msFlexNegative
            img.block.col-24(:src="img.qr")
        .col-24.flexD.justifyCenter
          q-btn(outline @click="openPopup(0)" :label="text.more" padding="3px 2.5em" :style="{ color: '#2196f3', fontSize: '1em' }")

    .m-hidden.flexD.flexDirectionColumn.alignItemsCenter.initBackgroundImage.l-padding-top-8em.l-padding-bottom-8em(v-else :style="{backgroundImage:'url('+ img.bg +')', backgroundSize: 'contain'}")
      .minWidth400.m-minWidthAuto.m-width-90-important(style="width: 40%")
        .col-24.flexD.justifyCenter.l-margin-bottom-2em
          .col-12.msFlexNegative
            img.col-24.block(:src="img.logo")
        .col-24
          .font-section.textAlignLeft(v-for="(item, index) in items" :key="index") {{ item.content }}
        .col-24.flexD.justifyCenter.l-margin-top-2em.l-margin-bottom-2em
          .col-4.msFlexNegative
            img.block.col-24(:src="img.qr")
        .col-24.flexD.justifyCenter
          q-btn(outline @click="openPopup(0)" :label="text.more" padding="3px 2.5em" :style="{ color: '#2196f3', fontSize: '1em' }")

    .l-hidden.m-flex.flexDirectionColumn.minWidth400.m-minWidthAuto.m-width-90-important(style="width: 40%")
      .col-24.flexD.justifyCenter.l-margin-bottom-2em
        .col-12.msFlexNegative
          img.col-24.block(:src="img.logo")
      .col-24
        .font-section.textAlignLeft(v-for="(item, index) in items" :key="index") {{ item.content }}
      .col-24.flexD.justifyCenter.l-margin-top-2em.l-margin-bottom-2em
        .col-4.m-width-50.msFlexNegative
          img.block.col-24(:src="img.qr")
      .col-24.flexD.justifyCenter
        q-btn(outline @click="openPopup(0)" :label="text.more" padding="3px 2.5em" :style="{ color: '#2196f3', fontSize: '1em' }")

    PopupDietz(ref="popupDietz" :content="popupValue")
</template>

<script>
  import PopupDietz from '../popup/popupDietz.vue'

  export default {
    name: 'dietz',
    props: ['content'],
    components: {
      PopupDietz,
      'q-parallax': Quasar.QParallax,
      'q-btn': Quasar.QBtn
    },
    data(){
      return{
        items: [
          {content: this.$t('dietz.content_1')},
          {content: this.$t('dietz.content_2')},
          {content: this.$t('dietz.content_3')},
        ],
        text: {
          more: this.$t('dietz.more')
        },
        img: {
          logo: require('@/assets/img/logo/logo_dietz.png'),
          bg: require('@/assets/img/bg_dietz.png'),
          qr: require('@/assets/img/qr_dietz.jpg'),
        },
        popupValue: {
          popup: false,
          index: 0
        }
      }
    },
    computed: {},
    methods:{
      openPopup(index){
        this.popupValue = {
          popup: true,
          index: index
        }
      },
    },
    created(){}
  }
</script>
